<div class="{{localService.selectedLanguageCode}}" *ngIf="localService.languageContent && localService.languageContent.refer">
  <div class="banner center" [ngStyle]="{'max-width' : '1000px'}">
    <div class="row freeze_height">
      <div class="col-md-5" style="text-align:center;">
        {{localService.languageContent.refer.refer_notes}}
      </div>
      <div class="col-md-7" style="text-align:right;">
        <button type="button" class="btn btn-primary" style="height: 100%;" (click)="onAction(1)">{{localService.languageContent.refer.copy_ref_code}}</button>
      </div>
    </div>
    <div class="row row_header freeze_height">
      <div class="col-3">
        {{localService.languageContent.refer.earned_on}}
      </div>
      <div class="col-3">
        {{localService.languageContent.refer.points}}
        <span class="en" *ngIf="wrapper">&nbsp;({{wrapper.total}})</span>
      </div>
      <div class="col-6">
        {{localService.languageContent.refer.refer_by}}
      </div>
    </div>
    <div class="custom_rows_body" [ngStyle]="{'max-height' : maxBodyHeight + 'px'}" *ngIf="wrapper && reasons">
      <div class="row styled_row" *ngFor="let item of wrapper.items" [ngStyle]="{'opacity' : item.isSelected ? '1' : '0.5'}">
        <div class="col-3">
          <span class="en">{{item.v6 | localDate}}</span>
        </div>
        <div class="col-3 en" style="text-align:right;">
          {{item.v1}}
        </div>
        <div class="col-6">
          <span>{{localService.getText(reasons,item.v5)}}</span>
          <span class="en">&nbsp;-&nbsp;</span>
          <span class="button" (click)="localService.showSummary(item.v2, 1)" [ngClass]="localService.getLanguageCode(item.v3)">{{item.v4}}</span>
        </div>
      </div>
    </div>
  </div>
  <app-paging *ngIf="wrapper" [paging]="wrapper.paging" [IsSimple]="true" [IsSimpleSearchBarReq]="false" (onPagingRefreshed)="onLoad()"></app-paging>
</div>
<span style="display:none;">
  <input type="button" class="on_language_changed" (click)="onLanguageChanged()" />
</span>
